module.exports = __webpack_public_path__ + "static/media/product-placeholder.b1a00a0b.png";